module.exports = __webpack_public_path__ + "static/media/transpoco.b3fc8514.png";